module.exports = __webpack_public_path__ + "img/logo_close.03ff7527.svg";